import { QarepaEnumInformation } from '@qarepa/common';

export enum PermitsValidateEnum {
  VALIDATE = 1,
  NO_VALIDATE = 0,
}

export const PermitsValidateArray = [
  PermitsValidateEnum.VALIDATE,
  PermitsValidateEnum.NO_VALIDATE,
];

export const PermitsValidateInfo: QarepaEnumInformation<PermitsValidateEnum> = {
  [PermitsValidateEnum.VALIDATE]: {
    name: $localize`Validado`,
  },
  [PermitsValidateEnum.NO_VALIDATE]: {
    name: $localize`No validado`,
  },
};
